import { Row, Col, Typography, Switch, Input, Divider } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../configureStore";

interface LivenessConfigurationFormProps {
    beforeSignature?: boolean;
    actionNeeded?: boolean;
    displayText?: string;
    onUpdate: (params: { beforeSignature?: boolean; actionNeeded?: boolean; displayText?: string }) => void;
}

export const LivenessConfigurationForm = ({
    beforeSignature,
    actionNeeded,
    displayText,
    onUpdate,
}: LivenessConfigurationFormProps) => {
    const loading = useSelector<RootState, boolean>(({ status: { loading: l } }) => l['institution/PATCH_INSTITUTION_STEPS']);
    const [draftDisplayText, setDraftDisplayText] = useState<string>(displayText ?? '');

    useEffect(() => {
        setDraftDisplayText(displayText ?? '');
    }, [displayText]);

    return (
        <>
            <Row align="middle" gutter={16} style={{ padding: '20px 0' }}>
                <Col flex="auto">
                    <Typography.Text>Liveness check before signature</Typography.Text>
                </Col>
                <Col>
                    <Switch
                        checked={beforeSignature ?? false}
                        onChange={(checked) => onUpdate({ beforeSignature: checked })}
                        loading={loading}
                    />
                </Col>
            </Row>
            <Divider style={{ margin: '8px 0' }} />
            <Row align="middle" gutter={16} style={{ padding: '20px 0' }}>
                <Col flex="auto">
                    <Typography.Text>Request action-needed webhook from TrueMark</Typography.Text>
                    <br />
                    <Typography.Text type="secondary">
                        TrueMark will send an action-needed webhook so the borrower can be prompted with custom copy.
                    </Typography.Text>
                </Col>
                <Col>
                    <Switch
                        checked={actionNeeded ?? false}
                        onChange={(checked) => onUpdate({ actionNeeded: checked })}
                        loading={loading}
                    />
                </Col>
            </Row>
            {actionNeeded && (
                <Row align="middle" gutter={16} style={{ padding: '20px 0' }}>
                    <Col span={24}>
                        <Typography.Text>Action-needed display text</Typography.Text>
                        <Input.TextArea
                            value={draftDisplayText}
                            onChange={(e) => setDraftDisplayText(e.target.value)}
                            onBlur={() => {
                                if (draftDisplayText !== (displayText ?? '')) {
                                    onUpdate({ displayText: draftDisplayText });
                                }
                            }}
                            placeholder="Text shown to the borrower when action is needed"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            disabled={loading}
                            style={{ marginTop: 8 }}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};
